import { inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';

interface HubSpotConversationsAPI {
  widget: {
    load: () => void;
    open: () => void;
    close: () => void;
    remove: () => void;
  };
}

interface HubspotSettings {
  loadImmediately: boolean;
  inlineEmbedSelector: string;
  enableWidgetCookieBanner: boolean;
  disableAttachment: boolean;
  identificationEmail?: string;
}

declare global {
  interface Window {
    HubSpotConversations: HubSpotConversationsAPI;
    hsConversationsOnReady: (() => void)[];
    hsConversationsSettings: HubspotSettings;
  }
}

@Injectable({
  providedIn: 'root',
})
export class HubspotChatService {
  private hubspotId = '4336872';
  private loaded = false;

  document = inject(DOCUMENT);

  loadHubspotChat(): void {
    if (this.loaded) {
      return;
    }

    try {
      const userStr = localStorage.getItem('user');
      let userEmail = '';
      if (userStr) {
        try {
          const user = JSON.parse(userStr);
          userEmail = user.email || '';
        } catch (error) {
          console.error('Erro ao obter email do usuário:', error);
        }
      }

      window.hsConversationsSettings = {
        loadImmediately: false,
        inlineEmbedSelector: '',
        enableWidgetCookieBanner: false,
        disableAttachment: false,
        identificationEmail: userEmail,
      };

      const script = this.document.createElement('script');
      script.src = `//js-na1.hs-scripts.com/${this.hubspotId}.js`;
      script.type = 'text/javascript';
      script.async = true;
      script.defer = true;
      script.id = 'hs-script-loader';

      script.onload = () => {
        this.loaded = true;
        this.attemptLoadHubspotWidget();
      };

      script.onerror = () => {
        console.error('Erro ao carregar o Hubspot Chat');
      };

      this.document.head.appendChild(script);
    } catch (error) {
      console.error('Erro ao carregar o Hubspot Chat:', error);
    }
  }

  private attemptLoadHubspotWidget(): void {
    const maxAttempts = 3;
    const intervalMs = 3 * 1000; // 3 seconds
    let attempts = 0;

    const tryLoad = () => {
      attempts++;

      if (window.HubSpotConversations) {
        window.HubSpotConversations.widget.load();
        return;
      }

      if (attempts < maxAttempts) {
        setTimeout(tryLoad, intervalMs);
      } else {
        console.error('Falha ao carregar o HubSpot widget após', maxAttempts, 'tentativas');
      }
    };

    setTimeout(tryLoad, intervalMs);
  }

  showChat(): void {
    if (window.HubSpotConversations) {
      window.HubSpotConversations.widget.open();
    }
  }

  hideChat(): void {
    if (window.HubSpotConversations) {
      window.HubSpotConversations.widget.close();
    }
  }

  removeChat(): void {
    if (window.HubSpotConversations) {
      window.HubSpotConversations.widget.remove();
    }
  }

  loadChat(): void {
    if (window.HubSpotConversations) {
      window.HubSpotConversations.widget.load();
    }
  }
}
